type PerExample = {
  id: 'salary' | 'non-salary'
  tabName: string
  image: 'salaryImage' | 'nonSalaryImage'
  title: string
  description: string
  grossAnnualIncome: number
  maximumDeductionlimit: number
  FortuneoPrice: number
  marginalTaxRate: number
  taxBenefits: number
  legalNotice: string
}

export type PerExampleId = PerExample['id']

export const perExamplesData: PerExample[] = [
  {
    id: 'salary',
    tabName: 'Salarié',
    image: 'salaryImage',
    title: 'Paul, salarié',
    description:
      "Paul ouvre pour la première fois un produit d’épargne retraite Fortuneo PER avec un versement initial de 10 000 € et ne bénéficie par ailleurs d'aucun dispositif de retraite professionnel.",
    grossAnnualIncome: 50000,
    maximumDeductionlimit: 18000,
    FortuneoPrice: 10000,
    marginalTaxRate: 30,
    taxBenefits: 3000,
    legalNotice:
      '*Plafond de déduction maximum = plafonds maximums de l’année en cours (10% revenus de l’année N-1) soit 4 500 € + le cumul des plafonds de déduction des 3 années passées non utilisés (4 500x3) = 4 500 € + 13 500 € = 18 000 €',
  },
  {
    id: 'non-salary',
    tabName: 'Non salarié',
    image: 'nonSalaryImage',
    title: 'Camille, non salariée',
    description:
      'Camille verse 15 000 € sur son plan d’épargne retraite Fortuneo PER cette année.',
    grossAnnualIncome: 100000,
    maximumDeductionlimit: 18045,
    FortuneoPrice: 15000,
    marginalTaxRate: 41,
    taxBenefits: 6150,
    legalNotice:
      '*Plafond de déduction maximum = 10% des bénéfices imposables de l’année N + 15% des bénéfices imposables de l’année compris entre 1 et 8 PASS 18 045 € = 10% de 100 000 € + 15% de 53 633 (=100 000 - 46 368)',
  },
]
